import threedocean from './3docean'
import audiojungle from './audiojungle'
import codecanyon from './codecanyon'
import graphicriver from './graphicriver'
import photodune from './photodune'
import themeforest from './themeforest'
import videohive from './videohive'
import defaults from './defaults'

export default {
  '3docean': threedocean,
  audiojungle,
  codecanyon,
  graphicriver,
  photodune,
  themeforest,
  videohive,
  defaults
}



// WEBPACK FOOTER //
// ./config/sites/index.js